import React from "react";
import type { CaseStudyContent } from "../../data/caseStudies";
import { CaseStudySection } from "./CaseStudySection";
import { BODY, H2, H3 } from "../../utils/typography";
type ResultsSectionProps = {
  results: CaseStudyContent["results"];
};
export function ResultsSection({
  results
}: ResultsSectionProps) {
  if (results.kind === "shifts") {
    return <CaseStudySection label={results.heading} data-id="element-111" data-mp="2m12uc4e5ykp4">
        <ul className="grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-8" data-id="element-112" data-mp="39pvl7mfxi2cv">
          {results.items.map(item => <li key={item.value} data-id="element-113" data-mp="3endwvklbyvok">
              <p className={`${H3} text-rust`} data-id="element-114" data-mp="2zz0xedn1aupb">
                {item.value}
              </p>
              <h3 className={`mt-4 ${BODY} font-medium text-espresso`} data-id="element-115" data-mp="2zx6k9li086vs">{item.label}</h3>
              {item.detail && <p className={`mt-2 ${BODY} text-espresso/70`} data-id="element-116" data-mp="3snomyletg68o">{item.detail}</p>}
            </li>)}
        </ul>
      </CaseStudySection>;
  }
  const [lead, ...supporting] = results.items;
  return <CaseStudySection label={results.heading} data-id="element-117" data-mp="3p8vt3uesfp1t">
      {lead && <div data-id="element-118" data-mp="3p7186g3inwxq">
          <p className={`${H2} text-rust`} data-id="element-119" data-mp="3p6sxmuuv93pp">
            {lead.value}
          </p>
          <p className="mt-3 text-sm font-medium uppercase tracking-wide text-espresso" data-id="element-120" data-mp="3k7y2ctfppmop">{lead.label}</p>
          {lead.detail && <p className={`mt-2 max-w-lg ${BODY} text-espresso/70`} data-id="element-121" data-mp="3u88hijlb546i">{lead.detail}</p>}
        </div>}
      {supporting.length > 0 && <ul className="mt-12 grid grid-cols-1 gap-10 sm:grid-cols-2 sm:gap-8" data-id="element-122" data-mp="bt7nnhk8ry2c">
          {supporting.map(item => <li key={item.value} data-id="element-123" data-mp="6umir4u1oq7k">
              <p className={`${H3} text-espresso`} data-id="element-124" data-mp="lsey9wzldelr">
                {item.value}
              </p>
              <p className="mt-3 text-sm font-medium uppercase tracking-wide text-espresso" data-id="element-125" data-mp="gtc457l5gssk">{item.label}</p>
              {item.detail && <p className={`mt-2 ${BODY} text-espresso/70`} data-id="element-126" data-mp="2nj9xkyt0bvx8">{item.detail}</p>}
            </li>)}
        </ul>}
      {results.note && <p className="mt-10 max-w-xl text-sm text-espresso/70" data-id="element-127" data-mp="2imjhwcl472cc">{results.note}</p>}
    </CaseStudySection>;
}